import React, { ReactNode } from "react";

interface PageShellProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
}

/**
 * PageShell — Layout base per una pagina dell'applicazione.
 * Mostra titolo, sottotitolo, pulsanti di azione opzionali e il contenuto principale.
 */
export const PageShell: React.FC<PageShellProps> = ({ title, subtitle, actions, children }) => {
  return (
    <div className="flex flex-col gap-6 px-20 pt-6">
      {/* Header */}
      <header className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && <p className="text-gray-500 text-sm mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </header>

      {/* Contenuto */}
      <section>{children}</section>
    </div>
  );
};
